import enviro from 'enviro';
import invariant from 'react-utils/invariant';
import isString from 'transmute/isString';
export const LOCAL_SETTINGS_PREFIX = 'LocalSettings:customerDataFiltersUI.customerDataFilters:';
export function makePrefixedKey(key) {
  invariant(isString(key) && key.length > 1, 'expected `key` to be a non-empty string but got `%s`', key);
  return LOCAL_SETTINGS_PREFIX + key;
}
export function getFrom(storage, key) {
  try {
    const entry = storage[makePrefixedKey(key)];
    if (entry === undefined) {
      return entry;
    }
    return JSON.parse(entry);
  } catch (error) {
    if (!enviro.isProd()) {
      console.error('Error: getFrom:', error);
    }
    return undefined;
  }
}
export function setFrom(storage, key, value) {
  try {
    storage[makePrefixedKey(key)] = JSON.stringify(value);
    return value;
  } catch (error) {
    if (!enviro.isProd()) {
      console.error('Error: setFrom:', error);
    }
    return undefined;
  }
}